module.exports = __webpack_public_path__ + "static/media/03liechesiji.6ccd863b.png";